// extracted by mini-css-extract-plugin
export var aboveInput = "_ln-0";
export var actionButton = "_ln-5";
export var actionButtonContainer = "_ln-1";
export var actionIcon = "_ln-6";
export var aiInfoContainer = "_ln-2";
export var attachmentWrapper = "_ln-7";
export var bold = "_ln-3";
export var checkIcon = "_ln-8";
export var clickingRecipientBar = "_ln-11";
export var commentThreadSwitch = "_ln-a";
export var draftImage = "_ln-b";
export var draftImageContainer = "_ln-c";
export var draftImages = "_ln-e";
export var editButton = "_ln-g";
export var editor = "_ln-f";
export var editorContainer = "_ln-y";
export var editorErrorTooltipWrapper = "_ln-9";
export var headerDivider = "_ln-h";
export var icon = "_ln-i";
export var info = "_ln-j";
export var internal = "_ln-n";
export var internalDivider = "_ln-k";
export var internalMessage = "_ln-l";
export var messageInputCard = "_ln-m";
export var messageInputForm = "_ln-o";
export var messageInputFormInternal = "_ln-p";
export var options = "_ln-q";
export var publicMessageCustomer = "_ln-s";
export var publicMessageMerchant = "_ln-r";
export var removeImageButton = "_ln-d";
export var replyButtons = "_ln-t";
export var showSignatureButton = "_ln-u";
export var spinner = "_ln-v";
export var verticalButtonDivider = "_ln-4";
export var visibilitySelector = "_ln-w";
export var warning = "_ln-x";
export var wrappingText = "_ln-z";
export var writingInternalNoteTopBorder = "_ln-10";